import ReferralModal from "components/components/modals/referralModal/referralModal";
import React, { useState } from "react";

const send 	= require("../../images/definitive/icn-send-qudos.png");

export default function Referrals({ info }) {
    const [referralModal, setReferralModal] = useState(false);


    return (
        <>
            <div className="card roundcard shadow mb-2">
                <div className="card-body">
                    <div className="row mb-4">
                        <div className="col-1">
                            <img src={send} className="mr-2" alt="send" />
                        </div>
                        <div className="col-9">Referrals</div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <button
                                type="button"
                                className="std-button-active"
                                onClick={() => setReferralModal(true)}
                            >
                                <div className="text-center">
                                    OPEN
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {referralModal && (
                <ReferralModal
                    show={referralModal}
                    setShow={setReferralModal}
                />
            )}
        </>
    );
}